import { render, staticRenderFns } from "./TsFilter.vue?vue&type=template&id=65713bcc&scoped=true&"
import script from "./TsFilter.vue?vue&type=script&lang=js&"
export * from "./TsFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsFilter.vue?vue&type=style&index=0&id=65713bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65713bcc",
  null
  
)

export default component.exports